import { render, staticRenderFns } from "./TaskRequestList.vue?vue&type=template&id=3c6c5f18&scoped=true"
import script from "./TaskRequestList.vue?vue&type=script&lang=js"
export * from "./TaskRequestList.vue?vue&type=script&lang=js"
import style0 from "./TaskRequestList.vue?vue&type=style&index=0&id=3c6c5f18&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c6c5f18",
  null
  
)

export default component.exports